'use client'

import ErrorPage from 'Clutch/Organisms/ErrorPage'

export default function Error() {
  return <ErrorPage statusCode={500} />
}
